import ConsultingAnalysisUpload from '../pages/ConsultingAnalysisUpload/consultingAnalysisUpload'
import ConsultingAnalysisList from '../pages/ConsultingAnalysisList/consultingAnalysisList'

export const routes = (t) => [
    {
        path: '/analysis/list',
        component: ConsultingAnalysisList,
        needToken: true,
        isAnalysisRoute: true,
        isAdvancedRoute: true,
        isManagedRoute: true,
        isBasicRoute: true,
        name: t('consultingAnalysis.list.title')
    },
    {
        path: '/analysis/upload',
        component: ConsultingAnalysisUpload,
        needToken: true,
        isAnalysisRoute: true,
        isAdvancedRoute: true,
        isManagedRoute: true,
        isBasicRoute: true,
        name: t('consultingAnalysis.upload.title')
    }
]
